import React, { useState } from 'react'
import HomeLayout from '../layouts/HomeLayout'
import { Formik } from 'formik'
import * as Yup from 'yup'
import instance from '../api/client'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import authService from '../authentication'
import AppContext from '../contexts/AppContext'
import jwtDecode from 'jwt-decode';
import { useContext } from 'react'
import { toast } from 'react-toastify'
import AppTextArea from '../components/formik/AppTextArea'
import AppInput from '../components/formik/AppInput'
import HomeSubmit from '../components/formik/HomeSubmit'
import Loader from '../components/loaders/Loader'
import LoginInput from '../components/formik/LoginInput'
import { faLock, faUserCircle } from '@fortawesome/free-solid-svg-icons'


const validationSchema = Yup.object().shape({
  otherNames: Yup.string().required().label("Other"),
  bio: Yup.string().required().label("Bio"),
  username: Yup.string().required().label("Username"),
  password: Yup.string().required().min(6).label("Password"),
  confirmPassword: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});

const existingValidationSchema = Yup.object().shape({
  username: Yup.string().required().label("Username"),
  password: Yup.string().required().min(6).label("Password"),
});

export default function AcceptInvite() {
  const [loading, setLoading] = useState(false)
  const { setUser } = useContext(AppContext)
  const navigate = useNavigate()
  const { id } = useParams()
  const { search } = useLocation()

  const isExisting = (new URLSearchParams(search).get('existing')) == 'true';

  const newUserAccept = async (form, { resetForm }) => {
    delete form.confirmPassword;
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/user/accept/${id}`, form)
      if (status == 200) {
        authService.setCurrentUser(data.token)
        setUser(jwtDecode(data.token))
        navigate('/dashboard')
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }

    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
    setLoading(false)
  }

  const existingUserAccept = async (form, { resetForm }) => {
    setLoading(true)
    try {
      const { data, status } = await instance.post(`/user/accept/${id}`, form)
      if (status == 200) {
        authService.setCurrentUser(data.token)
        setUser(jwtDecode(data.token))
        navigate('/dashboard')
      } else {
        toast.error(`Error: ${status}`, {
          position: toast.POSITION.TOP_CENTER
        });
      }

    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
    setLoading(false)
  }

  return (
    <>
      {loading &&
        <div style={{}} className='absolute z-50 flex w-full h-full items-center justify-center bg-modal'>
          <div className=' flex items-center justify-center'>
            <Loader animationName={'infinitywhite'} height={300} width={400} />
          </div>
        </div>
      }
      <HomeLayout>
        {/*HOMELAYOUT2*/}
        {
          isExisting ?
            <>
              <div>
                <div className=' text-3xl font-semibold md:text-3xl md:font-bold md:text-center'>
                  Hi, it's good to see you
                </div>
                <p className='py-2 md:py-3 text-left md:text-center md:text-lg text-slate-500'>Continue with google or enter your details</p>
                <button className='flex my-3 py-2 font-semibold rounded-md w-3/5 mx-auto border border-black items-center justify-center gap-2'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 48 48">
                    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"></path><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"></path><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"></path><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"></path>
                  </svg>Sign in with Google</button>

                <div className='flex items-center w-3/5 mx-auto justify-between'>
                  <hr className='border-3 border-slate-800 w-1/3'></hr>
                  <span className=' '>or</span>
                  <hr className='border-3 border-slate-800 w-1/3'></hr>
                </div>



                <Formik
                  initialValues={{ username: '', password: '' }}
                  validationSchema={existingValidationSchema}
                  onSubmit={existingUserAccept}
                >

                  <div className='w-3/5 mx-auto'>
                    <div className='w-full flex justify-center'>
                      <div className='mt-5 w-full'>
                        <LoginInput icon={faUserCircle} name={'username'} placeholder={'username'} type={'text'} />
                        <LoginInput icon={faLock} name={'password'} placeholder={'password'} type={'password'} />
                      </div>
                    </div>

                    <div className='flex justify-between items-center my-2 mx-5 mt-8'>
                      <div>
                        <input id='remember' type='checkbox' /><label for='remember' className='ml-1 font-semibold'>Remember me</label>
                      </div>
                      <button className='font-semibold underline'>Forgot Password</button>
                    </div>

                    <div className='mt-10 font-semibold'>
                      <HomeSubmit teal text={'Sign in'} />
                    </div>

                    <div className='text-md text-center p-3'>
                      <span>New Here?
                        <Link to={'/signup'} className='font-semibold text-teal-600'> Create an account</Link>
                      </span>
                    </div>
                  </div>
                </Formik>
              </div>
            </>
            :
            <>
              <div className='mb-2 text-2xl text-center font-bold md:text-3xl capitalize'>
                Create an account
              </div>
              <div className='w-1/4 h-[2.5px] bg-slate-700 mx-auto' />
              <Formik
                initialValues={{ otherNames: '', username: '', password: '', confirmPassword: '', bio: '' }}
                validationSchema={validationSchema}
                onSubmit={newUserAccept}
              >
                <>
                  <div className={`transition-all ease-in-out duration-3000 slide `}>
                    <div className={`gap-4 w-full block`}>
                      <div className='flex gap-3 mt-5'>
                        <AppInput boxClassName={'w-1/2'} label={'other name(s)'} name={'otherNames'} placeholder={'Jenkins'} type={'text'} />
                        <AppInput boxClassName={'w-1/2'} label={'username'} name={'username'} placeholder={'Doe'} type={'text'} />
                      </div>
                    </div>

                    <div className={`gap-4 w-full block`}>
                      <AppInput label={'password'} name={'password'} placeholder={'*******'} type={'password'} />
                      <AppInput label={'confirm password'} name={'confirmPassword'} placeholder={'*******'} type={'password'} />
                      <AppTextArea rows={5} label={'bio'} name={'bio'} placeholder={'Tell us something about yourself'} />
                    </div>

                    <HomeSubmit teal text={'SUBMIT'} />
                  </div>
                </>
              </Formik>
            </>
        }

      </HomeLayout>
    </>
  )
}
